<template>
    <div class="invite-dropdown">
        <common-button
            v-if="display"
            class="invite-dropdown--button"
            :label="buttonLabel"
            type="primary"
            size="medium"
            :isClicked="isDropdownOpen"
            :icon="isDropdownOpen ? 'minus' : 'referral-add'"
            @click="toggleDropdown"
        ></common-button>

        <common-dropdown
            v-clickaway="closeDropdown"
            :isOpen="isDropdownOpen"
            :hasArrow="hasArrow"
            bgColor="gray"
            arrowPositionY="top"
            arrowPositionX="left"
        >
            <common-dropdown-items :isSubItems="true" :menuItems="menuItems" @item-clicked="itemClicked"></common-dropdown-items>
        </common-dropdown>
    </div>
</template>
<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],
        props: {
            buttonLabel: { type: String, required: true },
            display: { type: Boolean, required: false, default: true },
            openInviteModal: { type: Function, required: true },
            menuItems: { type: Array, required: true },
            hasArrow: { type: Boolean, default: false },
        },
        data() {
            return {
                isDropdownOpen: false,
                PracticeTypeEnum: PracticeTypeEnum,
            }
        },
        methods: {
            toggleDropdown() {
                this.isDropdownOpen = !this.isDropdownOpen
            },

            closeDropdown() {
                this.isDropdownOpen = false
            },

            itemClicked(payload) {
                this.openInviteModal(payload)
            },
        },
    }
</script>

<style lang="scss">
    .invite-dropdown {
        position: relative;
        .app-user-dropdown__menu {
            min-width: 150px;
        }

        &--button {
            min-width: 220px !important;
        }
    }
</style>
